const EmergencyServiceHouse = [
	{
		id: '5301',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Bed Sheet(Single)',
		category: 'Household',
		service: 'Emergency Service',
		subservice: 'Wash And Iron',
		price: 120,
		quantity: 1
	},
	{
		id: '5302',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Bed Sheet(Single)',
		category: 'Household',
		service: 'Emergency Service',
		subservice: 'Iron And Fold',
		price: 65,
		quantity: 1
	},
	{
		id: '5303',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Bed Sheet(Single)',
		category: 'Household',
		service: 'Emergency Service',
		subservice: 'Dry Cleaning',
		price: 150,
		quantity: 1
	},

	{
		id: '5204',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Bed Sheet(Double)',
		category: 'Household',
		service: 'Emergency Service',
		subservice: 'Wash And Iron',
		price: 230,
		quantity: 1
	},
	{
		id: '5305',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Bed Sheet(Double)',
		category: 'Household',
		service: 'Emergency Service',
		subservice: 'Iron And Fold',
		price: 130,
		quantity: 1
	},
	{
		id: '5306',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Bed Sheet(Double)',
		category: 'Household',
		service: 'Emergency Service',
		subservice: 'Dry Cleaning',
		price: 250,
		quantity: 1
	},

	{
		id: '5307',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Sofa Cover',
		category: 'Household',
		service: 'Emergency Service',
		subservice: 'Wash And Iron',
		price: 150,
		quantity: 1
	},
	{
		id: '5308',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Sofa Cover',
		category: 'Household',
		service: 'Emergency Service',
		subservice: 'Iron And Fold',
		price: 70,
		quantity: 1
	},
	{
		id: '5309',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Sofa Cover',
		category: 'Household',
		service: 'Emergency Service',
		subservice: 'Dry Cleaning',
		price: 170,
		quantity: 1
	},
	{
		id: '5310',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Carpet',
		category: 'Household',
		service: 'Emergency Service',
		subservice: 'Wash And Iron',
		price: 50,
		quantity: 1
	},
	{
		id: '5311',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Carpet',
		category: 'Household',
		service: 'Emergency Service',
		subservice: 'Iron And Fold',
		price: 200,
		quantity: 1
	},

	{
		id: '5210',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Travel Bag',
		category: 'Household',
		service: 'Emergency Service',
		subservice: 'Wash And Iron',
		price: 120,
		quantity: 1
	},
	{
		id: '5210',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Travel Bag',
		category: 'Household',
		service: 'Emergency Service',
		subservice: 'Iron And Fold',
		price: 190,
		quantity: 1
	},
	{
		id: '5210',
        ac: 'd-block',
        dc: 'd-none',
		name: 'Travel Bag',
		category: 'Household',
		service: 'Emergency Service',
		subservice: 'Dry Cleaning',
		price: 170,
		quantity: 1
	}
];
export default EmergencyServiceHouse;
